<template>
    <div class="container">

        <div @change="uploadFile($event)" class="upload-file__container" >
            <label for="upload-file">Subir archivo<i class="material-icons">file_upload</i></label>
            <input type="file" id="upload-file">
        </div>

        <div v-if="uploaded">
            {{ `https://lmsforgestorage.blob.core.windows.net/contentresources/${uploaded}` }}
        </div>
    </div>
</template>


<script setup>
import storage from "./azure-storage";
import { ref } from 'vue';

const uploaded = ref(false)

async function uploadFile(event) {
    uploaded.value = false;
    let file = event.target.files[0];
    let fileCDN = await storage.updateFile(file,'content');
    uploaded.value = fileCDN;

}

</script>

<style lang="scss" scoped>

.container {
    width: 100%;
    height: 100vh;
    margin-top: 20vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

</style>